import { render } from "./DocumentationMenu.vue?vue&type=template&id=aebcacaa&scoped=true&ts=true"
import script from "./DocumentationMenu.vue?vue&type=script&lang=ts"
export * from "./DocumentationMenu.vue?vue&type=script&lang=ts"

import "./DocumentationMenu.vue?vue&type=style&index=0&id=aebcacaa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebcacaa"]])

export default __exports__